import React, { useEffect, useState } from 'react';
import { PageTitle, PseudoStates } from '@cordata/buffet';
import { useParams } from 'react-router-dom';
import { deburrObject } from '~/utils/api/normalizers';
import { authorizedPyInstance as Py } from '~/utils';
import { format } from 'date-fns';

import { Form } from '~/components/Medication';

const MedicationsDetails = () => {
  const { medicationId, ...p } = useParams();
  const [status, setStatus] = useState('loading');
  const [data, setData] = useState();

  useEffect(() => {
    if (medicationId !== 'add') {
      Py
        .get(`api/data/public/patient-medication/${medicationId}`)
        .then(r => deburrObject(r.data.data))
        .then(r => Object.keys(r).reduce((a, m) => {
          return {
            ...a,
            [m]: r[m] && typeof r[m] === 'object' && !Array.isArray(r[m]) ? deburrObject(r[m]) : r[m],
          };
        }, {}))
        .then(setData)
        .then(() => setStatus('success'))
        .catch(() => setStatus('error'));
    } else {
      setData({});
      setStatus('success');
    }
  }, [medicationId]);

  if (status === 'success') {
    return (
      <>
        <PageTitle>
          Medication
        </PageTitle>

        <Form
          data={{
            ...data,
            ...[
              'startedDate',
              'finishedDate',
            ].reduce((a, m) => ({
              ...a,
              [m]: data[m] ? format(data[m], 'MM/DD/YYYY') : undefined,
            }), {}),
            patientUid: { id: p.patient_id },
          }}
        />
      </>
    );
  }

  return <PseudoStates status={status} />;
};

export default MedicationsDetails;
